import { render } from "./CookiesDomPrint.vue?vue&type=template&id=42cb46a2&scoped=true&ts=true"
import script from "./CookiesDomPrint.vue?vue&type=script&lang=ts"
export * from "./CookiesDomPrint.vue?vue&type=script&lang=ts"

import "./CookiesDomPrint.vue?vue&type=style&index=0&id=42cb46a2&lang=css"
import "./CookiesDomPrint.vue?vue&type=style&index=1&id=42cb46a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cb46a2"]])

export default __exports__